import { createRoot } from 'react-dom/client';

import { ScorecardApp } from './components/ScorecardApp';
import { type ScorecardConfig } from './types';

declare global {
  interface Window {
    InteractScorecardData?: ScorecardConfig;
  }
}

const selectBlocks = () =>
  Array.from(
    document.querySelectorAll<HTMLElement>('[data-ai-scorecard="true"][data-hydrated="false"]'),
  );

const hydrateBlock = (root: HTMLElement) => {
  const eyebrow = root.dataset.eyebrow || '';
  const heading = root.dataset.heading || 'The AI intranet demo scorecard';
  const subheading = root.dataset.subheading || '';

  root.innerHTML = '';
  root.dataset.hydrated = 'true';

  const mount = createRoot(root);
  mount.render(<ScorecardApp eyebrow={eyebrow} heading={heading} subheading={subheading} />);
};

const start = () => {
  const hydrate = () => selectBlocks().forEach(hydrateBlock);

  const observer = new MutationObserver(hydrate);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  hydrate();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', start);
} else {
  start();
}
